import { FileTextOutlined } from "@ant-design/icons";
import { playerNotesCore } from "./core/playerNotes";
import { defineWidget } from "../widgetDefinition";
import { playerNotesSlots } from "../Slots";
import { playerNotesDuplicate } from "../Duplication/playerNotes";
import { playerNotesControlPanel } from "../ControlPanel/playerNotes";
import type { PlayerNotesComponentSpec } from "../Processing/types";
import { PlayerNotesWidget } from "../WidgetComponents/PlayerNotesWidget";
import { PlayerNotesInfo } from "../Info/playerNotes";
import { PlayerNotesConfigurator } from "../AddWidgetModal/PlayerNotesConfigurator";
import { BINDABLE_SECTIONS } from "../Processing/controllerBindings";

export const playerNotesDefinition = defineWidget<PlayerNotesComponentSpec>({
  ...playerNotesCore,
  type: "player_notes",
  dynamic: { bindableSections: BINDABLE_SECTIONS.player_notes },
  slots: playerNotesSlots,
  duplicate: playerNotesDuplicate,
  controlPanel: playerNotesControlPanel,
  info: { Content: PlayerNotesInfo },
  schema: ["display", "queryId", "player_notes_builder_misc"],
  contractHash: "1ak2efaznve",
  needsData: true,

  template: {
    label: "Player Notes",
    description: "Display a filtered player note",
    icon: <FileTextOutlined />,
  },

  defaultLayout: { w: 4, h: 5, minW: 3, minH: 4 },

  gridComponent: ({ id }) => <PlayerNotesWidget id={id} />,

  configurator: {
    modalTitle: "Player Notes",
    wide: true,
    Component: PlayerNotesConfigurator as React.ComponentType<any>,
  },
});
